import React from "react";
import Pill from "../../ui/atoms/Pill";

interface ResourcePillProps {
  value: string;
}

const ResourcePill: React.FC<ResourcePillProps> = ({ value }) => {
  return <Pill className="resource-pill">{value}</Pill>;
};

export default ResourcePill;
